import React, { useContext } from 'react'
import { BackButton } from '../utils/Elements'
import InvoiceStatusHelper from '../helpers/InvoiceStatusHelper'
import InvoiceStatus from './InvoiceStatus'
import Context from '../context/Context'
import Bankgiro from './payment/Bankgiro'
import Swish from './payment/Swish'
import OneClick from './payment/OneClick'
import PropTypes from 'prop-types'

const Payment = ({ onToggleSpecification }) => {
  const context = useContext(Context)

  if (InvoiceStatusHelper.shouldInvoiceBePaid(context.invoice)) {
    return (
      <div>
        <div className="row mt-5">
          <div className="col-12 text-center">
            <h1>Välj betalsätt</h1>
          </div>
        </div>
        {context.organizationSettings.showInvoiceLines === '0' &&
          <Bankgiro onToggleSpecification={onToggleSpecification} />
        }
        <Swish />
        <OneClick />
        <div className="row mt-2">
          <div className="col-12 text-center">
            <BackButton style={context.style} />
          </div>
        </div>
      </div>
    )
  } else {
    return <InvoiceStatus />
  }
}

Payment.propTypes = {
  onToggleSpecification: PropTypes.func.isRequired
}

export default Payment
